// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"319":"62785951","583":"86354070","833":"4cab0693","910":"28e6b283"}[chunkId] + ".chunk.js";
};